var map = {
	"./Attrezzo/Form": 961,
	"./Attrezzo/Form.vue": 961,
	"./Attrezzo/Index": 2347,
	"./Attrezzo/Index.vue": 2347,
	"./Attrezzo/Show": 6909,
	"./Attrezzo/Show.vue": 6909,
	"./Auth/ConfirmPassword": 2722,
	"./Auth/ConfirmPassword.vue": 2722,
	"./Auth/ForgotPassword": 6834,
	"./Auth/ForgotPassword.vue": 6834,
	"./Auth/Login": 8416,
	"./Auth/Login.vue": 8416,
	"./Auth/Register": 1515,
	"./Auth/Register.vue": 1515,
	"./Auth/ResetPassword": 2095,
	"./Auth/ResetPassword.vue": 2095,
	"./Auth/VerifyEmail": 1254,
	"./Auth/VerifyEmail.vue": 1254,
	"./Contact/Form": 6122,
	"./Contact/Form.vue": 6122,
	"./Contact/Index": 7561,
	"./Contact/Index.vue": 7561,
	"./Dashboard": 2802,
	"./Dashboard.vue": 2802,
	"./DashboardEsercizio": 3021,
	"./DashboardEsercizio.vue": 3021,
	"./Esercizio/Dettaglio": 741,
	"./Esercizio/Dettaglio.vue": 741,
	"./Esercizio/Form": 8773,
	"./Esercizio/Form.vue": 8773,
	"./Esercizio/Index": 3303,
	"./Esercizio/Index.vue": 3303,
	"./Esercizio/Show": 4844,
	"./Esercizio/Show.vue": 4844,
	"./Paziente/Dettaglio": 1926,
	"./Paziente/Dettaglio.vue": 1926,
	"./Paziente/DettaglioPratica": 6463,
	"./Paziente/DettaglioPratica.vue": 6463,
	"./Paziente/Form": 9571,
	"./Paziente/Form.vue": 9571,
	"./Paziente/FormPratica": 2346,
	"./Paziente/FormPratica.vue": 2346,
	"./Paziente/Index": 4023,
	"./Paziente/Index.vue": 4023,
	"./Paziente/Show": 1005,
	"./Paziente/Show.vue": 1005,
	"./TipoEsercizio/Form": 7941,
	"./TipoEsercizio/Form.vue": 7941,
	"./TipoEsercizio/Index": 9340,
	"./TipoEsercizio/Index.vue": 9340,
	"./TipoEsercizio/Show": 3550,
	"./TipoEsercizio/Show.vue": 3550,
	"./TipoTest/Form": 9277,
	"./TipoTest/Form.vue": 9277,
	"./TipoTest/Index": 6491,
	"./TipoTest/Index.vue": 6491,
	"./TipoTest/Show": 8377,
	"./TipoTest/Show.vue": 8377,
	"./Welcome": 5426,
	"./Welcome.vue": 5426
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3218;